import {
  GET_PERMISSIONS,
  GET_PERMISSIONS_SUCCESS,
  GET_PERMISSIONS_FAIL,
  GET_PERMISSION_BY_ID_SUCCESS,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
};

const Permission = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_PERMISSIONS:
      return {
        ...state,
        loading: true,
      };
    case GET_PERMISSIONS_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_PERMISSION_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };
    case GET_PERMISSIONS_FAIL:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
};

export default Permission;
